/**
 * As páginas que podem ter anúncio. É lista do que pode (allowlist) de
 * propósito: página nova não ganha anúncio sem alguém decidir. Carrinho,
 * pagamento, perfil, suporte, formulários, Discord, download, páginas legais e
 * o construtor ficam de fora.
 */
const PERMITIDAS: RegExp[] = [
  /^\/$/,
  /^\/loja(\/.*)?$/,
  /^\/noticias$/,
  /^\/noticias\/(?!publicar$)[^/]+$/,
  /^\/noticia\/[^/]+$/,
  /^\/forum$/,
  /^\/forum\/[^/]+\/[^/]+$/,
  /^\/forum\/[^/]+\/[^/]+\/(?!new-topic$)[^/]+$/,
  /^\/wiki(\/.*)?$/,
  /^\/jogadores$/,
  /^\/p\/[^/]+$/,
];

export function rotaPermiteAnuncio(caminho: string): boolean {
  const limpo = caminho.length > 1 ? caminho.replace(/\/+$/, '') : caminho;
  return PERMITIDAS.some((r) => r.test(limpo));
}
